import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['sail', 0.22],
        ['shrine', 0.78],
      ],
      d: 'M-1,-5h0.5v0.5h-0.5zM-1.5,-4.5h1v0.5h-1zM-2,-4h2v1h-2zM-2,-1h1v0.5h-1zM1.5,-1h0.5v0.5h-0.5zM-1.5,-0.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['shadow', 0.24],
        ['shrine', 0.76],
      ],
      d: 'M-0.5,-5h1v0.5h-1zM0,-4.5h1.5v0.5h-1.5zM0,-4h2v0.5h-2zM0,-3.5h1.5v0.5h-1.5zM-1,-3h1v0.5h-1zM0.5,-3h1v2.5h-1zM-0.5,-2.5h0.5v0.5h-0.5zM-0.5,-1h0.5v0.5h-0.5zM-2.5,-0.5h1v0.5h-1zM1.5,-0.5h0.5v0.5h-0.5zM-2,0h1.5v0.5h-1.5zM0.5,0h1.5v0.5h-1.5zM-1,0.5h2v0.5h-2z',
    },
    {
      paint: 'shrine',
      d: 'M0.5,-5h0.5v0.5h-0.5zM-0.5,-4.5h0.5v0.5h-0.5zM-1.5,-3h0.5v2h-0.5zM0,-3h0.5v2.5h-0.5zM-1,-1h0.5v0.5h-0.5zM0,-0.5h1.5v0.5h-1.5zM-0.5,0h1v0.5h-1z',
    },
    { paint: 'shadow', d: 'M-1,-2.5h0.5v0.5h-0.5zM-1,-2h1v0.5h-1zM-1,-1.5h0.5v0.5h-0.5z' },
    { paint: 'fountain', d: 'M-0.5,-1.5h0.5v0.5h-0.5z' },
  ],
  pixels: 78,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
